import type { UserInfoFormData } from "./store/types";

type ValidationErrors = Partial<Record<keyof UserInfoFormData, string>>;

export const validateUserInfoForm = (
  formData: UserInfoFormData
): ValidationErrors => {
  const errors: ValidationErrors = {};

  // Validate name
  if (!formData.name.trim()) {
    errors.name = "First name is required";
  }

  // Validate surname
  if (!formData.surname.trim()) {
    errors.surname = "Last name is required";
  }

  // Validate password
  if (!formData.password) {
    errors.password = "Password is required";
  } else if (formData.password.length < 6) {
    errors.password = "Password must be at least 6 characters";
  }

  // Validate confirm password
  if (!formData.confirmPassword) {
    errors.confirmPassword = "Please confirm your password";
  } else if (formData.password !== formData.confirmPassword) {
    errors.confirmPassword = "Passwords do not match";
  }

  return errors;
};
